import {
  type ContractorInvoice,
  type ContractorInvoiceAPI,
  ContractorInvoiceStateEnum,
  ContractorInvoiceStateEnumAPI,
  type CreateInvoicePaymentRequest,
  type CreateInvoicePaymentRequestAPI,
  type CreateInvoiceQuoteRequest,
  type CreateInvoiceQuoteRequestAPI,
  type CreateInvoiceRequest,
  type CreateInvoiceRequestAPI,
  type GetContractorInvoicesResponse,
  type GetContractorInvoicesResponseAPI,
} from '@omnipresentgroup/types';

/**
 * Mappers
 */
const transformContractorInvoiceStateFromAPI = (
  state: ContractorInvoiceStateEnumAPI,
): ContractorInvoiceStateEnum => {
  const mapping: Record<
    ContractorInvoiceStateEnumAPI,
    ContractorInvoiceStateEnum
  > = {
    [ContractorInvoiceStateEnumAPI.CANCELLED]:
      ContractorInvoiceStateEnum.CANCELLED,
    [ContractorInvoiceStateEnumAPI.IN_PROGRESS]:
      ContractorInvoiceStateEnum.IN_PROGRESS,
    [ContractorInvoiceStateEnumAPI.OPEN]: ContractorInvoiceStateEnum.OPEN,
    [ContractorInvoiceStateEnumAPI.PAID]: ContractorInvoiceStateEnum.PAID,
    [ContractorInvoiceStateEnumAPI.REJECTED]:
      ContractorInvoiceStateEnum.REJECTED,
  };
  return mapping[state];
};

export const transformContractorInvoiceFromAPI = ({
  id,
  state,
  contractor,
  client,
  amount,
  currency,
  due_date,
  description,
  raised_at,
  paid_at,
  overdue_by,
  invoice_ref,
  attachments,
  payment_id,
  billing_currency,
}: ContractorInvoiceAPI): ContractorInvoice => ({
  id,
  state: transformContractorInvoiceStateFromAPI(state),
  contractor,
  client,
  amount,
  currency,
  dueDate: due_date,
  description,
  raisedAt: raised_at,
  paidAt: paid_at,
  overdueBy: overdue_by,
  invoiceRef: invoice_ref,
  attachments,
  paymentId: payment_id,
  billingCurrency: billing_currency,
});

export const transformGetContractorInvoicesResponseFromAPI = ({
  items,
  total,
  page,
  size,
  pages,
}: GetContractorInvoicesResponseAPI): GetContractorInvoicesResponse => ({
  items: items.map((item) => transformContractorInvoiceFromAPI(item)),
  total,
  page,
  size,
  pages,
});

export const transformCreateInvoiceRequestToAPI = (
  payload: CreateInvoiceRequest,
): CreateInvoiceRequestAPI => {
  return {
    invoice_ref: payload.invoiceRef,
    currency: payload.currency,
    amount: payload.amount,
    due_date: payload.dueDate,
    description: payload.description,
    attachments: payload.attachments,
  };
};

export const transformCreateInvoiceQuoteRequestToAPI = (
  payload: CreateInvoiceQuoteRequest,
): CreateInvoiceQuoteRequestAPI => {
  return {
    invoices: payload.invoices,
    allow_partial_payment: payload.allowPartialPayment,
  };
};

export const transformCreateInvoicePaymentRequestToAPI = (
  payload: CreateInvoicePaymentRequest,
): CreateInvoicePaymentRequestAPI => ({ quote_id: payload.quoteId });
